import {
  ButtonBlock,
  LineBlock,
  RowTileBlock,
  ScopedBlock,
  SpacerBlock,
  TextBlock,
  VideoBlock,
} from "@moim/blockit";
import React from "react";
import GridBlock from "./blocks/grid";
import { ImageBlock } from "./blocks/image";
import SectionBlock from "./blocks/section";

interface IProps {
  block: Moim.Blockit.V2.BlockType;
  className?: string;
}

const BlockitRendererV2: React.FC<IProps> = ({ block, className }) => {
  // if (!block.version?.startsWith("2")) {
  //   return <BlockitRenderer block={block as Moim.Blockit.Blocks} />;
  // }

  switch (block.type) {
    case "carousel": {
      return <></>;
      // return <CarouselBlock className={className} {...block} />;
    }
    case "text": {
      return <TextBlock className={className} {...block} />;
    }
    case "image": {
      return <ImageBlock className={className} {...block} />;
    }
    case "grid": {
      return <GridBlock className={className} {...block} />;
    }
    case "product-list-preview": {
      return <></>;
      // return <ProductListPreview className={className} {...block} />;
    }
    case "product-list": {
      return <></>;
      // return <ProductList className={className} {...block} />;
    }
    case "content-group-preview": {
      return <></>;
      // return <ContentsGroupPreview className={className} {...block} />;
    }
    case "content-group": {
      return <></>;
      // return <ContentsGroupPreview className={className} {...block} />;
    }
    case "spacer": {
      return <SpacerBlock className={className} {...block} />;
    }
    case "line":
      return <LineBlock className={className} {...block} />;
    case "section": {
      return <SectionBlock className={className} {...block} />;
    }
    case "quick-link-navigation": {
      return <></>;
      // return <QuickLInkNavigation className={className} {...block} />;
    }
    case "brand-list-preview": {
      return <></>;
      // return <BrandListPreview className={className} {...block} />;
    }
    case "button": {
      return <ButtonBlock className={className} {...block} />;
    }

    case "dquest-group-preview": {
      return <></>;
      // return <DquestGroupPreview {...block} />;
    }
    case "category": {
      return <></>;
      // return <CommerceCategory {...block} />;
    }
    case "child-moim-group":
      return <></>;
    // return <ChildMoimGroup {...block} />;
    case "child-moim-group-preview":
      return <></>;
    // return <ChildMoimGroupPreview {...block} />;

    case "video":
      return <VideoBlock {...block} />;

    case "nft-summary":
      return <></>;
    // return <NFTSummaryBlock {...block} />;
    case "nft-group-preview":
      return <></>;
    // return <NFTGroupPreview {...block} />;
    case "nft-collection-preview":
      return <></>;
    // return <NFTCollectionPreviewBlock {...block} />;
    case "cryptobadge-group-preview":
      return <></>;
    // return <CryptobadgeGroupPreview {...block} />;
    case "row-tile":
      return <RowTileBlock {...block} />;

    case "scoped-block":
      return <ScopedBlock {...block} />;
    default: {
      return null;
    }
  }
};

export default BlockitRendererV2;
